module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('request-status', {
    attrs: {
      "request": _vm.req,
      "message200": false
    }
  }), _vm._v(" "), (_vm.withTitle) ? _c('v-card-title', {
    staticClass: "overline py-0"
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "icon": "",
      "loading": _vm.req.loading
    },
    on: {
      "click": _vm.get
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("replay")])], 1), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm._f("appointment.full_name")(_vm.appointment.title)))])], 1) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.financials) ? _c('v-card-text', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('div', {
    staticClass: "li"
  }, [_c('span', {
    staticClass: "overline"
  }, [_vm._v("Appointment price")]), _c('br'), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.formatCurrency(_vm.appointment.currency, _vm.financials.appointment_unit_price)))])]), _vm._v(" "), (_vm.financials.products_total_price && parseInt(_vm.financials.products_total_price) > 0) ? _c('div', {
    staticClass: "li"
  }, [_c('span', {
    staticClass: "overline"
  }, [_vm._v("Product sales")]), _c('br'), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.formatCurrency(_vm.appointment.currency, _vm.financials.products_total_price)))])]) : _vm._e(), _vm._v(" "), (_vm.financials.appointment_tax && parseInt(_vm.financials.appointment_tax) > 0) ? _c('div', {
    staticClass: "li"
  }, [_c('span', {
    staticClass: "overline"
  }, [_vm._v("Tax")]), _c('br'), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.formatCurrency(_vm.appointment.currency, _vm.financials.appointment_tax)))])]) : _vm._e(), _vm._v(" "), _c('v-divider', {
    staticClass: "my-2"
  }), _vm._v(" "), (_vm.financials.appointment_dicount && parseInt(_vm.financials.appointment_dicount) > 0) ? _c('div', {
    staticClass: "li"
  }, [_c('span', {
    staticClass: "overline"
  }, [_vm._v("Discount")]), _c('br'), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.formatCurrency(_vm.appointment.currency, _vm.financials.appointment_dicount)))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "li"
  }, [_c('span', {
    staticClass: "overline"
  }, [_vm._v("Payments")]), _c('br'), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.formatCurrency(_vm.appointment.currency, _vm.financials.payments_received)))])]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "overline"
  }, [_vm._v("Due")]), _c('br'), _vm._v(" "), _c('strong', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.formatCurrency(_vm.appointment.currency, _vm.finalPrice)))])])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-09136862","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/appointment/edit/AppointmentPriceDetails.vue
// module id = 1321
// module chunks = 9